import { InvalidImageFileError } from '../errors/InvalidImageFileError';

/**
 * Matches the bucket's own constraints (see
 * infra/supabase/migrations/006_create_site_media_bucket.sql) so a rejected
 * upload fails fast with a clear Persian message here, instead of only
 * surfacing as an opaque Supabase Storage error after the network round trip.
 */
const MAX_FILE_SIZE_BYTES = 5 * 1024 * 1024; // 5MB
const ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'image/gif', 'image/svg+xml'];

export function validateImageFile(file: File): void {
  if (!ALLOWED_MIME_TYPES.includes(file.type)) {
    throw new InvalidImageFileError(
      `unsupported file type "${file.type || 'unknown'}". Allowed: ${ALLOWED_MIME_TYPES.join(', ')}.`
    );
  }
  if (file.size > MAX_FILE_SIZE_BYTES) {
    throw new InvalidImageFileError(
      `file is too large (${Math.round(file.size / 1024 / 1024)}MB). Maximum is 5MB.`
    );
  }
  if (file.size === 0) {
    throw new InvalidImageFileError('file is empty.');
  }
}
